import request from '@/utils/request'
import qs from 'qs'
import { getIdentityServerBase } from '@/utils/oidc'

export function refreshToken(data) {
  return request({
    url: 'connect/token',
    method: 'post',
    isError: true,
    data: qs.stringify(data),
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    baseURL: getIdentityServerBase()
  })
}
export function CookieLogout(data) {
  return request({
    url: 'Account/CookieLogout',
    method: 'post',
    data: data,
    withCredentials: true,
    baseURL: getIdentityServerBase()
  })
}

export function ViewCoreOperations(data) {
  return request({
    url: 'Event/ViewCoreOperations',
    method: 'post',
    data: data,
    baseURL: getIdentityServerBase()
  })
}
